import { render } from "./CommonLogoSetting.vue?vue&type=template&id=383f1320&scoped=true"
import script from "./CommonLogoSetting.vue?vue&type=script&lang=js"
export * from "./CommonLogoSetting.vue?vue&type=script&lang=js"

import "./CommonLogoSetting.vue?vue&type=style&index=0&id=383f1320&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383f1320"]])

export default __exports__